import { render } from "./NewCourse.vue?vue&type=template&id=53f0a43c&scoped=true"
import script from "./NewCourse.vue?vue&type=script&lang=js"
export * from "./NewCourse.vue?vue&type=script&lang=js"

import "./NewCourse.vue?vue&type=style&index=0&id=53f0a43c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f0a43c"]])

export default __exports__